import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'usb-item-transport-detail-summary',
  templateUrl: './item-transport-detail-summary.component.html',
  styleUrls: ['./item-transport-detail-summary.component.scss']
})
export class ItemTransportDetailSummaryComponent implements OnInit {
  @Input() item: any;
  i: any;
  constructor() { }

  ngOnInit() {
  }

}
